/**
 * IPermissions interface
 */
import { RequireOnly, StrictUnion } from '../../ts.utils';

export enum SupportedAppCodes {
  XDM = 'XDM',
  XBOF = 'XBOF',
  XPOS = 'XPOS',
  XPRT = 'XPRT',
  XVI = 'xvi',
}

export enum PermissionValue {
  View = 'View',
  Edit = 'Manage',
  Add = 'Add',
}

export enum PermissionType {
  action = 'action',
  crud = 'crud',
  custom = 'custom',
}

/**
 * Detailed permission check result
 * Contains permission status along with identifying information
 */
export interface IPermissionCheckResult {
  /** Whether the user has this permission */
  hasPermission: boolean;
  /** The permission name (e.g., 'inventory-item.View') */
  name: string;
  /** The application code (e.g., 'XVI', 'XDM') or null for default app */
  app_code: SupportedAppCodes | null;
}

export type IUserPermBuilder = (
  allPermissions: CpxUserPermission[],
) => StrictUnion<
  | CpxUserPermission
  | CpxUserPermission[]
  | RequireOnly<IPermissionCheckResult, 'name' | 'hasPermission'>
>;

export interface IUserPermission {
  name: string;
  app_code: SupportedAppCodes;
  value?: boolean | number;
  type?: PermissionType;

  customHasPermissionCheck?: PermCustomCheckFunction;
}

export type PermCustomCheckFunction = (
  perm: Omit<IUserPermission, 'customHasPermissionCheck'>,
  userPermissions: IUserPermission[],
) => boolean;

export type CpxUserPermission = string | IUserPermission | IUserPermBuilder;

export interface IUserPermissions {
  total: number;
  items: IUserPermission[];
}

export interface IPermissions {
  name: string;
  app_code: SupportedAppCodes;
  roles: string[];
}
